<template>

<div>

    <h1>Create new affiliate</h1>

    <div class="box">

      <Errors/>

      <form class="form" v-on:submit.prevent="createAffiliate">

        <AffiliateFields/>

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled>Creating...</button>
          </div>
          <div v-else>
            <button type="submit" class="button">Create affiliate</button>
          </div>
        </div>

      </form>

    </div>

</div>

</template>

<script>
import AffiliateFields from '@/components/AffiliateFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'AffiliateCreate',
  computed: mapGetters(['getLoadStatus']),
  data () {
    return {
      affiliate: {},
      errors: null
    }
  },
  components: {
    AffiliateFields,
    Errors
  },
  methods: {
    createAffiliate () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'affiliates', {
        method: 'POST',
        body: JSON.stringify(this.affiliate),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success) {
          if(this.$route.path == '/bookings/create') {
            this.$parent.creatingAffiliate = false
            this.$parent.booking.affiliate = response.data
          } else {
            this.$router.push({ name: 'affiliate-edit', params: { id: response.data.id }})
          }
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
}
</script>
